import { render, staticRenderFns } from "./TabSettings.vue?vue&type=template&id=5ffa89fc&scoped=true&"
import script from "./TabSettings.vue?vue&type=script&lang=js&"
export * from "./TabSettings.vue?vue&type=script&lang=js&"
import style0 from "./TabSettings.vue?vue&type=style&index=0&id=5ffa89fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa89fc",
  null
  
)

export default component.exports